// src/patient2/Patient2BottomNav.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Search, HeartPulse, Settings } from "lucide-react";
import "./patient2.css";

export default function Patient2BottomNav() {
  return (
    <nav className="p2-bottom-nav">
      <NavLink
        to="/patient2/home"
        className={({ isActive }) =>
          "p2-bottom-item" + (isActive ? " active" : "")
        }
      >
        <Home size={20} />
        <span>Home</span>
      </NavLink>

      <NavLink
        to="/patient2/explore"
        className={({ isActive }) =>
          "p2-bottom-item" + (isActive ? " active" : "")
        }
      >
        <Search size={20} />
        <span>Explore</span>
      </NavLink>

      <NavLink
        to="/patient2/my-health"
        className={({ isActive }) =>
          "p2-bottom-item" + (isActive ? " active" : "")
        }
      >
        <HeartPulse size={20} />
        <span>My Health</span>
      </NavLink>

      <NavLink
        to="/patient2/settings"
        className={({ isActive }) =>
          "p2-bottom-item" + (isActive ? " active" : "")
        }
      >
        <Settings size={20} />
        <span>Settings</span>
      </NavLink>
    </nav>
  );
}
